// Marketing pixel helpers — Meta + TikTok.
// Both load conditionally based on env vars and no-op safely when keys are missing.

const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const TIKTOK_PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;

let loaded = false;

export function initMarketingPixels() {
  if (loaded || typeof window === "undefined") return;
  loaded = true;

  // --- Meta Pixel ---
  if (META_PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0;
      t.src = v; s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  }

  // --- TikTok Pixel ---
  if (TIKTOK_PIXEL_ID) {
    /* eslint-disable */
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = (w[t] = w[t] || []);
      ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];
      ttq.setAndDefer = function (t, e) {
        t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      };
      ttq.load = function (e, n) {
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        var o = document.createElement("script");
        o.type = "text/javascript"; o.async = !0;
        o.src = i + "?sdkid=" + e + "&lib=" + t;
        var a = document.getElementsByTagName("script")[0];
        a.parentNode.insertBefore(o, a);
      };
      ttq.load(TIKTOK_PIXEL_ID);
      ttq.page();
    })(window, document, "ttq");
    /* eslint-enable */
  }
}

// Safe event firers — guarded so ad-blockers can't crash the app.
export function trackMeta(event, data = {}) {
  if (META_PIXEL_ID && typeof window !== "undefined" && window.fbq) {
    try { window.fbq("track", event, data); } catch (e) {}
  }
}

export function trackTikTok(event, data = {}) {
  if (TIKTOK_PIXEL_ID && typeof window !== "undefined" && window.ttq) {
    try { window.ttq.track(event, data); } catch (e) {}
  }
}

// Convenience: fire both pixels for the same logical event.
export function trackPurchase({ value, currency = "AUD", contentIds = [] }) {
  trackMeta("Purchase", { value, currency, content_ids: contentIds });
  trackTikTok("CompletePayment", { value, currency, content_id: contentIds[0] });
}

export function trackInitiateCheckout({ value, currency = "AUD", contentIds = [] }) {
  trackMeta("InitiateCheckout", { value, currency, content_ids: contentIds });
  trackTikTok("InitiateCheckout", { value, currency, content_id: contentIds[0] });
}

export function trackAddToCart({ value, currency = "AUD", contentIds = [] }) {
  trackMeta("AddToCart", { value, currency, content_ids: contentIds });
  trackTikTok("AddToCart", { value, currency, content_id: contentIds[0] });
}

export function trackLead(email) {
  trackMeta("Lead", { email });
  trackTikTok("SubmitForm", { email });
}
